import axiosIns from '@/libs/axios'

const ROOT_URL = '/data/products'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      title: null,
      summary: null,
      content: null,
      slug: null,
      ordering: null,
      seo_title: null,
      seo_description: null,
      seo_keywords: null,
      id_brands: null,
      id_product_categories: null,
      id_users: null,
      images: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        title: null,
        summary: null,
        content: null,
        slug: null,
        ordering: null,
        seo_title: null,
        seo_description: null,
        seo_keywords: null,
        id_brands: null,
        id_product_categories: null,
        id_users: null,
        images: [],
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = params
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.dataCount)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      const data = {
        where: {
          id: Number(id),
        },
        array: false,
      }
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = postData
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    saveImage({ commit }, params) {
      return axiosIns
        .post(`${ROOT_URL}/save-image`, params)
        .then(response => {
          // commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeImageData({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/delete-image`, { id })
        .then(response => {
          commit('SET_DATA_SAVE2', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    reOrderingImages({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/re-ordering-images`, data)
        .then(response => {
          // commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    resetDataItem({ commit }) {
      commit('RESET_DATA_ITEM')
    },
  },
}
